module.exports = __webpack_public_path__ + "static/customer_photo_2-de58ebb4ef30e5f0bd36196ff3449f83.jpg";